import * as React from "react";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { GridFilterCellProps } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { filterClearIcon } from "@progress/kendo-svg-icons";

interface DropdownFilterCellProps extends GridFilterCellProps {
  defaultItem: string;
  data: string[];
  onToggle?: (isFilterFocused: boolean) => void;
}

export const DropdownFilterCell = (props: DropdownFilterCellProps) => {
  const hasValue = (value: string) => Boolean(value && value !== props.defaultItem);

  const onChange = (event: DropDownListChangeEvent) => {
    const valueHasChanged = hasValue(event.target.value);
    props.onChange({
      value: valueHasChanged ? event.target.value : "",
      operator: valueHasChanged ? "eq" : "",
      syntheticEvent: event.syntheticEvent,
    });
  };

  const handleFocus = () => {
    // Set the focus state to true when the dropdown gains focus
    if (props.onToggle) props.onToggle(true);
  };

  const handleFocusLost = () => {
    // Set the focus state to false when the dropdown loses focus
    if (props.onToggle) props.onToggle(false);
  };

  const onClearButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();
    props.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };

  return (
    <div className="k-filtercell">
      <DropDownList
        style={{ marginRight: 5 }}
        data={props.data}
        onChange={onChange}
        value={props.value || props.defaultItem}
        defaultItem={props.defaultItem}
        onFocus={handleFocus}
        onBlur={handleFocusLost}
        onClose={handleFocusLost}
      />
      <Button title="Clear" disabled={!hasValue(props.value)} onClick={onClearButtonClick} svgIcon={filterClearIcon} />
    </div>
  );
};
